import addPanelDataConsts from '#packages/addPanelDataConsts';
import blogWelcome from './blogWelcome';

const blogWelcomeSection = {
  type: addPanelDataConsts.SECTIONS_TYPES.GENERAL,
  hide: false,
  title: 'add_section_label_newblog',
  showSectionHeader: true,
  props: {
    class: 'no-space-before-section invisible-header',
    template: blogWelcome,
  },
  help: {
    hide: false,
    text: 'add_section_label_membersarea_tooltip_description',
  },
};

export default {
  getCategorySections() {
    return {
      blogWelcomeSection,
    };
  },
};
